import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Api from '../../../services/Api';
import './UploadFileModal.scss';

const UploadFileModal = ({
  callback,
  imagesOnly,
  endpoint,
  className,
  additionalPostParams,
  uploadInProgressCallback,
}) => {
  const inputRef = useRef();
  const showOpenFileDialog = () => {
    inputRef.current.click();
  };
  const handleFileUpload = (event) => {
    if (event.target.files.length === 0) {
      return;
    }
    const fileToUpload = event.target.files[0];
    if (uploadInProgressCallback) {
      uploadInProgressCallback(fileToUpload);
    }
    Api.uploadOneFile(endpoint, fileToUpload, additionalPostParams || {})
      .then((response) => {
        if (callback) {
          callback(response.data, fileToUpload);
        }
      })
      .then(() => {
        // eslint-disable-next-line no-param-reassign
        event.target.value = null;
      });
  };
  return (
    <>
      <button type="button" className={className} onClick={showOpenFileDialog}>
        <FontAwesomeIcon icon={solid('plus')} color="#000" />
      </button>
      <input
        type="file"
        style={{ display: 'none' }}
        ref={inputRef}
        onChange={handleFileUpload}
        accept={`${imagesOnly ? 'image/*' : ''}`}
      />
    </>
  );
};

UploadFileModal.propTypes = {
  callback: PropTypes.func,
  imagesOnly: PropTypes.bool,
  endpoint: PropTypes.string,
  className: PropTypes.string,
  additionalPostParams: PropTypes.objectOf(PropTypes.any),
  uploadInProgressCallback: PropTypes.func,
};

UploadFileModal.defaultProps = {
  callback: undefined,
  imagesOnly: false,
  endpoint: '/images',
  className: '',
  additionalPostParams: undefined,
  uploadInProgressCallback: undefined,
};

export default UploadFileModal;
